module.exports = __webpack_public_path__ + "img/LTS_SNG.8896c215.gif";